// extracted by mini-css-extract-plugin
export const container = "CruiseExcursionsList-module--container--R3ocK";
export const columnNew = "CruiseExcursionsList-module--column-new--3JUSH";
export const columnName = "CruiseExcursionsList-module--column-name--1ZWHA";
export const columnActivityLevel = "CruiseExcursionsList-module--column-activity-level--1ZB8p";
export const columnAccessibility = "CruiseExcursionsList-module--column-accessibility--1KdsL";
export const columnIcons = "CruiseExcursionsList-module--column-icons--2IygR";
export const columnViewMore = "CruiseExcursionsList-module--column-view-more--tNXDZ";
export const table = "CruiseExcursionsList-module--table--3sFBx";
export const sectionTitle = "CruiseExcursionsList-module--section-title--2_8AT";
export const iconNewInline = "CruiseExcursionsList-module--icon-new-inline--2uE98";
export const title = "CruiseExcursionsList-module--title--29K7q";
export const code = "CruiseExcursionsList-module--code--2qB5X";
export const icons = "CruiseExcursionsList-module--icons--5W8Dg";